import React from 'react';
import {
  Button,
} from '@material-ui/core';
import { AddCircleOutline } from '@material-ui/icons';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';

export default function AddButton({ disabled, handleClick }) {
  const classes = fieldStyles();

  return (
    <Button
      className={classes.editButton}
      variant='contained'
      size='large'
      disabled={disabled}
      onClick={handleClick}
      startIcon={<AddCircleOutline />}
    >
      {translations['_add']}
    </Button>
  );
}

// Indica i controla els props que se han de passar al component
AddButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};
